import React from 'react';
import InquiryStatusSelect from './InquiryStatusSelect';

const InquiryStatusFilter = ({ onChange }) => {
  return <InquiryStatusSelect onChange={onChange} withClearButton />;
};
export default InquiryStatusFilter;
